window.Vue = require('vue');

Vue.component('session-list', require('./components/SessionList').default);
Vue.component('dummy-clock', require('./components/DummyClock').default);
Vue.component('session-live', require('./components/SessionLive').default);
Vue.component('favorite-session', require('./components/FavoriteSession').default);
Vue.component('session-status', require('./components/SessionStatus').default);
Vue.component('redeem-ticket', require('./components/RedeemTicket').default);
Vue.component('video-player', require('./components/Videojs').default);
Vue.component('vue-youtube', require('./components/VueYoutube').default);
Vue.component('vue-vimeo', require('./components/VueVimeo').default);
Vue.component('vue-autocomplete', require('./components/VueAutocomplete').default);
Vue.component('session-responsive', require('./components/SessionResponsive').default);
Vue.component('advert-display', require('./components/AdvertDisplay').default);
Vue.component('zoom-orgs', require('./components/ZoomOrgs').default);

const app = new Vue({
    el: '#app'
});